// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__lgCMP","valueContainer":"Select_valueContainer__Dxks6","menu":"Select_menu__3ocDh","fadeIn":"Select_fadeIn__jjU-y","opacity":"Select_opacity__Bgq5d"};